import {
  FilterMethod,
  KnownCompaniesInclusionMethod,
} from "@/generated/company-search";
import type { CompanyFilters } from "../../types";
import { defaultKnownCompaniesSlice, type KnownCompaniesSlice } from "./slice";

/**
 * Converts slice state to CompanyFilters for API queries.
 * Only produces a filter once the upload succeeded.
 */
export function toCompanyFilters(
  slice: KnownCompaniesSlice
): Partial<CompanyFilters> {
  if (slice.uploadState !== "SUCCESS" || !slice.identifier) {
    return {};
  }

  return {
    knownCompanies: {
      identifier: slice.identifier,
      inclusionMethod:
        slice.filterMethod === FilterMethod.EXCLUDE_MATCHED
          ? KnownCompaniesInclusionMethod.NONE_PRESENT
          : KnownCompaniesInclusionMethod.ANY_PRESENT,
      includeHierarchy: slice.includeHierarchy,
      fileName: slice.fileName,
      totalRows: slice.totalRows,
      invalidRows: slice.invalidRows,
      matchedRows: slice.matchedRows,
      uploaded: slice.uploadedAt,
    },
  };
}

/**
 * Hydrates slice state from saved CompanyFilters.
 */
export function fromCompanyFilters(
  filters: CompanyFilters
): KnownCompaniesSlice {
  const known = filters.knownCompanies;
  if (!known?.identifier) {
    return defaultKnownCompaniesSlice;
  }

  return {
    uploadState: "SUCCESS",
    identifier: known.identifier,
    fileName: known.fileName ?? null,
    totalRows: known.totalRows ?? null,
    invalidRows: known.invalidRows ?? null,
    matchedRows: known.matchedRows ?? null,
    includeHierarchy: known.includeHierarchy ?? false,
    filterMethod:
      known.inclusionMethod === KnownCompaniesInclusionMethod.NONE_PRESENT
        ? FilterMethod.EXCLUDE_MATCHED
        : FilterMethod.FILTER,
    error: null,
    uploadedAt: known.uploaded ?? null,
  };
}
